import React from 'react'
import styled from 'styled-components'
import {motion} from 'framer-motion'
import Me from '../assets/Images/profile-img.png'


const Box = styled(motion.div)`

position: absolute;
left: 50%;
top: 50%;
transform: translate(-50%, -50%);
width: 65vw;
height:55vh;
display: flex;


background: linear-gradient(
    to right,
    ${props => props.theme.body} 50%,
    ${props => props.theme.text} 50%) bottom,
    linear-gradient(
    to right,
    ${props => props.theme.body} 50%,
    ${props => props.theme.text} 50%) top;
    background-repeat: no-repeat;
    background-size: 100% 2px;
    border-left: 2px solid ${props => props.theme.body};
    border-right: 2px solid ${props => props.theme.text};


    z-index:1;
   @media (max-width: 768px){
   height: 120vh;
    width: 65vw;
    
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    
    margin: auto;

    background: linear-gradient(
      to bottom,
      ${props => props.theme.body} 50%,
      ${props => props.theme.text} 50%) right,
      linear-gradient(
      to bottom,
      ${props => props.theme.body} 50%,
      ${props => props.theme.text} 50%) left;
    background-repeat: no-repeat;
    background-size: 2px 100%;

    border-left: none;
    border-right: none;
    border-top: 2px solid ${props => props.theme.body};
    border-bottom: 2px solid ${props => props.theme.text};

    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
     z-index:1;
   }


`
const SubBox = styled.div`
width: 50%;
position: relative;
display: flex;

.pic{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%,0%);
    width: 100%;
    height: auto;
}
      @media (max-width: 768px) {
    width: 100%;
    height: 50%;
    
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:1;

    .pic {
    width: 85%; /* Adjust width as needed */
    height:100%; /* Adjust height as needed */
    object-fit: cover;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index:3;
    }
      
  }
`

const Text = styled.div`
font-size: calc(1em + 1.5vw);
color: ${props => props.theme.body};
padding: 2rem;
cursor: pointer;

display: flex;
flex-direction: column;
justify-content: space-evenly;

&>*:last-child{
    color: ${props => `rgba(${props.theme.bodyRgba},0.6)` };
    font-size: calc(0.5rem + 1.5vw);
    font-weight:300;

}
  @media (max-width: 768px) {
    color: ${props => props.theme.body};
    font-size: calc(1rem + 1.5vw);
    font-weight:300;

    padding: 2rem;
    line-height: 1.15
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;      
    text-align:justify;
    z-index:1;
    &>*:first-child{
      padding-bottom:0.5rem;
    }
    &>*:last-child{
      font-size: calc(0.75rem + 1.25vw);
      padding-top:0.5rem;
    }

  }


`

const Intro = () => {
    return (
        <Box
        initial={{height:0}}
        animate={{height: '55vh'}}
        transition={{ type: 'spring', duration:2, delay:1 }}
        >
            <SubBox>
                <Text>
                    <h1>Hi,</h1>
                    <h3>I'm Mohan Prasath</h3>
                    <h6>An highly skilled and self-driven software engineer. I design and code simple yet beautiful websites.</h6>
                </Text>
            </SubBox>
            <SubBox>
                <motion.div
                initial={{opacity:0}}
        animate={{opacity: 1}}
        transition={{ duration:1, delay:2 }}
                >
                    <img className="pic" src={Me} alt="Profile Pic" />
                </motion.div>
            </SubBox>
        </Box>
    )
}

export default Intro




